import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: 'home',
        component: HomeComponent,
        title: 'KeepItGreen4U'
      },
      {
        path: 'about',
        component: AboutComponent,
        title: 'KeepItGreen4U'
      },
      {
        path: 'contact',
        component: ContactComponent,
        title: 'KeepItGreen4U'
      },
      {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ])

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
